<template>
  <div class="line-item">
    <div class="heading ml-2" style="display: flex" @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE')">
      <v-btn
        class="mx-0"
        icon
        @click.prevent="
          $store.myActions.UI_TOGGLE_MISSION_MAP_VISIBILITY({ missionId: mission.misId, uiid: detailUiid })
        "
        :title="
          $t(
            mapVisibility[mission.misId]
              ? 'Pilot.MissionDrawer.HideMissionTooltip'
              : 'Pilot.MissionDrawer.ShowMissionTooltip'
          )
        "
        ><v-icon>{{ mapVisibility[mission.misId] ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon></v-btn
      >
      <mission-state :mission="mission" small />
      <v-btn
        class="missionbtn mx-0 pr-2"
        :class="{ testMission: mission.isTestMission }"
        flat
        @click.prevent="
          $store.myActions.UI_TOGGLE_MISSION_INFOS_VISIBILITY({ missionId: mission.misId, uiid: detailUiid })
        "
        :title="
          $t(
            detailVisibility[mission.misId]
              ? 'Pilot.MissionDrawer.HideMoreMissionInfosTooltip'
              : 'Pilot.MissionDrawer.ShowMoreMissionInfosTooltip'
          )
        "
        >{{ mission.misLibelle }}
        <mission-surfacage :mission="mission" :viewList="true" />
        <v-icon :class="{ rotate180: detailVisibility[mission.misId] }" style="margin-left: auto"
          >mdi-chevron-down</v-icon
        ></v-btn
      >
      <v-btn
        class="mx-0"
        small
        icon
        v-show="mapVisibility[mission.misId]"
        @click.prevent="
          $store.myActions.UI_SELECT_MISSION_MAP({
            id: mission.misId,
            uiid: missionState.typeUiid == 'global' ? 'map_global' : ''
          })
        "
        :title="$t('Pilot.MissionDrawer.SelectMissionTooltip')"
        ><v-icon :class="{ active: mission.misId == currentMissionMapId }">mdi-crosshairs-gps</v-icon></v-btn
      >
      <mission-color
        class="mx-0"
        v-show="mapVisibility[mission.misId]"
        :uiid="uiid"
        :mission="mission"
        v-if="$vuetify.breakpoint.name != 'xs'"
      />
      <v-btn
        class="mx-0"
        small
        v-if="accesPilotReachDetail.visible"
        :disabled="!accesPilotReachDetail.enable"
        icon
        flat
        :to="accesPilotReachDetail.enable ? { name: 'MissionDetail', params: { missionid: mission.misId } } : null"
        :title="$t('Pilot.MissionDrawer.ReachMissionPageTooltip')"
        ><v-icon>mdi-forward</v-icon></v-btn
      >
    </div>
    <v-expand-transition>
      <mission-line-detail
        class="elevation-5 mx-1 mb-2 px-2 pb-2 pt-0"
        v-if="detailVisibility[mission.misId]"
        :mission="mission"
        :uiid="uiid"
        :shownav="true"
      />
    </v-expand-transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import MissionTimeLine from '@/components/mission/MissionTimeLine'
import MissionRangeTimeLine from '@/components/mission/MissionRangeTimeLine'
import MissionState from '@/components/mission/MissionState'
import MissionColor from '@/components/mission/MissionColor'
import { AloMission } from '@/models/alo/AloMission'
import MissionLineDetail from '@/components/mission/MissionLineDetail'
import { stylesList, defaultMapStyle } from '@/components/map/MapStyles'
import { SecurityItemsKeys } from '../../enum/SecurityItems'
import { buildFleetUIStateId } from '@/models/ui/FleetUiState'
import MissionSurfacage from '@/components/mission/MissionSurfacage'

export default {
  name: 'MissionLine',
  props: {
    mission: {
      type: AloMission
    },
    uiid: {
      type: String,
      required: true
    }
  },
  created() {
    this.$options.stylesList = stylesList
    this.$options.defaultMapStyle = defaultMapStyle
  },
  components: {
    MissionTimeLine,
    MissionRangeTimeLine,
    MissionLineDetail,
    MissionColor,
    MissionState,
    MissionSurfacage
  },
  computed: {
    ...mapGetters([
      'missionUiStateByUiid',
      'fleetUiStateByUiid',
      'currentMissionMapId',
      'coordFormatFilter',
      'missionMapVisibility',
      'missionDetailVisibility',
      'currentDetailFleet'
    ]),
    mapVisibility() {
      return this.missionState.typeUiid == 'global'
        ? this.missionMapVisibility
        : this.fleetUiStateByUiid(this.detailUiid).missionMapVisibility
    },
    detailVisibility() {
      return this.missionState.typeUiid == 'global'
        ? this.missionDetailVisibility
        : this.fleetUiStateByUiid(this.detailUiid).missionDetailVisibility
    },
    detailUiid() {
      return this.missionState.typeUiid == 'global'
        ? ''
        : buildFleetUIStateId(this.currentDetailFleet.fleet.FLE_ID, 'detail')
    },
    accesPilotReachDetail() {
      return this.mission.security[SecurityItemsKeys.PILOT_REACH_DETAIL]
    },
    missionState() {
      //retourne un MissionUiState
      return this.missionUiStateByUiid(this.uiid)
    }
  },
  methods: {}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.rotate180 {
  transform: rotate(-180deg);
}

.missionbtn .v-icon {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
}

.testMission {
  font-style: italic;
  color: rgb(128, 128, 128) !important;
}

.line-item {
  border-bottom: 1px solid #eee;
}
.line-item .active {
  color: #4caf50 !important;
}

.line-item .heading {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.missionbtn {
  flex: 1 0 auto;
}

.missionbtn .v-btn__content {
  justify-content: flex-start;
}
</style>
